import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


import { AVScanReq } from '../model/avscan-req';
import { ScanResponseInfo } from '../model/scan-response-info';
import { ScanSubmitResponse } from '../model/scan-submit-response';
import { AgileSDKService } from './agile-sdk.service';

@Injectable({
  providedIn: 'root'
})
export class AntiVirusScanService {

  avApis = environment.avScanApis;
  constructor(private httpClient:HttpClient, private agileSdkServ:AgileSDKService) { }

  submitForAVScan(fileNameWithPath:string){

    const headers = { }
  console.log('Submitting '+fileNameWithPath+" for AV Scan....")
  //  return this.httpClient.post<ScanSubmitResponse>(avApis.SubmitForScan.postRequest,{headers,params:{filename:fileNameWithPath}});
  return this.httpClient.post<ScanSubmitResponse>(this.avApis.SubmitForScan.postRequest+"?filename="+fileNameWithPath,headers);
}

submitForAVScanV2(fileScanRequest:AVScanReq){

  fileScanRequest.userName = this.agileSdkServ.urlParams.userName;
  const headers = { }
console.log('Submitting '+fileScanRequest+" for AV Scan....")
//  return this.httpClient.post<ScanSubmitResponse>(avApis.SubmitForScan.postRequest,{headers,params:{filename:fileNameWithPath}});
return this.httpClient.post<ScanSubmitResponse>(this.avApis.SubmitForScanV2.postRequest,fileScanRequest).pipe(retry(3));
}

  getAVScanStatus(fileNameWithPath:string){

    return this.httpClient.get<ScanResponseInfo>(this.avApis.GetScanResponse.getRequest,{params:{filename:fileNameWithPath}}).pipe(retry(3));
    
  }
}
